<template>
  <div id="departments" style="padding:25px">
    <ListCard :list="create_list" @getCreateInfo="chooseClick" v-if="!createForm"></ListCard>
    <div class="create-item" v-if="createForm">
      <el-form size="mini" ref="form" label-width="200px">
        <div v-for="(item, index) in pageInfo" :key="index">
          <PageList :page="item.column" :pageId="pageId" :change.sync="item.value" :reset="resetNum"
            :checkReq.sync="item.req" @MFValue="getMF">
          </PageList>
        </div>
        <el-form-item>
          <el-button type="primary" :loading="btnLoading" @click="submitForm">{{ $t("message.button.createNow")
          }}</el-button>
          <el-button @click="reset">{{ $t("message.button.reset") }}</el-button>
          <el-button @click="breadcrumbClick" type="success">{{ $t("message.button.cancel") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ListCard from "./common/listCard.vue";
import PageList from "./common/pageList.vue";
import { getNewData, checkSubformRequied, getSaveUrl } from "../../utils/setDataFormat";
export default {
  name: "Quality",
  data() {
    return {
      createForm: false,
      pageInfo: [],
      columnOne: {},
      pageId: {},
      pageData: [],
      resetNum: 0,
      typeName: '',

      loading: true,
      create_list: [],
      multiList: [],
      saveUrl: '',
      btnLoading: false,

    };
  },
  components: {
    ListCard,
    PageList,
  },
  props: {
    baseId: {
      default: 101,
      type: Number
    },
  },
  methods: {

    getMF(e) {
      this.manufacturerId = e;
    },
    breadcrumbClick() {
      this.createForm = false;
      this.pageInfo = [];
      this.btnLoading = false
      // this.getPartsList();
    },
    getDataList(arr) {
      console.log(arr);

      if (arr.length === 3) {
        const tablistList = [...arr]
        return { tablistList }
      }
      const [lifeCircleRes, ...abc] = arr
      return { lifeCircleRes, tablistList: [...abc] }
    },
    async chooseClick(e) {
      console.log(e);
      this.pageId = e;
      this.typeName = e.name
      this.createForm = true;

      const arr = [1, 2, 3].map(i => axios.get(`/pmdm/admin/getVisibleTableColumnInfo/${e.id}/${i}`));

      const list = e.baseClsId === 106 ? [this.getlfcircle(), ...arr] : [...arr];
      // const
      Promise.all(list).then(res => {
        let arr = [];
        const { lifeCircleRes = '', tablistList } = this.getDataList(res);
        const lifeCircleListEntry = {};
        if (lifeCircleRes) {
          lifeCircleRes.data.object.phases.map(i => {
            const { id, phaseName } = i
            lifeCircleListEntry[id] = phaseName
          });
        }

        this.pageInfo = tablistList.map((i, e) => {
          const column = i.data.object.columnInfo;

          const { listEntries, listIds, ids, listTypes } = column;
          const index = ids.indexOf(1012003);
          listEntries['99'] = lifeCircleListEntry;
          index !== -1 && (listIds[index] = 99);
          listTypes[index] = 9

          const req = getNewData(column).filter(j => j.required);
          arr = [...arr, ...req]
          return { column: i.data, value: {} }
        })
        console.log(this.pageInfo);

        this.reqFields = arr;
      })
    },

    getlfcircle() {
      const obj = { url: '/pmdm/admin/lifecycle/getLifecyclePhaseByClass', id: 106, query: { clsId: 10501 }, columnId: 1012003 };
      return axios.get(`${obj.url + this.params(obj.query)}`)
    },



    submitForm() {
      this.btnLoading = true;
      const req = this.pageInfo.map(i => i.req).every(i => !!i);
      const pageVal = this.pageInfo.map((i) => i.value);

      if (!req) {
        const columns = this.pageInfo.map(i => i.column.object.columnInfo);
        const str = checkSubformRequied({ columns, vals: pageVal });
        this.$message.error(this.$t('message.tips.requiredError') + str)
        this.btnLoading = false;
        return
      }

      const { clsId: classId, id: subClassId } = this.pageId
      const [pageOne, pageTwo, pageThree] = pageVal;
      pageOne['classId'] = classId;
      this.baseId === 106 && (pageOne['manufacturerId'] = this.manufacturerId)
      const objectId = {
        classId, subClassId,
        id: "",
      };

      const obj = { pageOne, pageTwo, pageThree, objectId }
      this.submit(obj);
    },
    submit(obj) {
      const saveUrl = getSaveUrl(this.baseId);
      axios.post(saveUrl, obj).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          const item = {
            ...res.data.object,
            name: res.data.object.name
          }
          this.getLink(item);
        } else {
          this.btnLoading = false
        }
      }).catch(_ => {
        this.btnLoading = false
      })
    },
    reset() {
      this.resetNum++;
    },

    async getLists() {

      this.loading = true;
      const { data } = await axios.get(
        `/pmdm/admin/cls/getClsesWithSubClses?baseClsId=${this.baseId}`
      );
      if (data.code !== 200) return this.$message.error(res.message);
      this.create_list = data.object.clses.map(i => {
        i.show = true;
        return i
      });
      this.loading = false
    },

  },
  created() {
    this.getLists();
  },
};
</script>

<style scoped>
#departments {
  height: 92%;
}

.create-item {
  overflow: auto;
  height: 100%;
  padding: 10px 10px;
  background: #fff;
}

.title {
  font-size: 16px;
  /* margin-left: 10px; */
  /* color: #409eff; */
  margin-bottom: 10px;
  margin-top: 20px;
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
}

.title .el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  font-weight: 400;
  /* color: #409eff; */
}

.box-card {
  margin-top: 15px;
  padding-top: 15px;
}

.create-list {
  padding: 0;
  margin: 0;
  overflow: hidden;
  margin-bottom: 30px;
}

.create-list-subClass {
  width: 24%;
  height: 30px;
  float: left;
  text-align: center;
  background: #ebeef5;
  margin-right: 1%;
  margin-top: 10px;
  line-height: 30px;
  border-radius: 6px;
}

.create-list-subClass:hover {
  cursor: pointer;
  background: #409eff;
  color: #fff;
}

.create-list .create-list-class {
  width: 96%;
  background: rgb(198, 226, 255);
  text-align: left;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  cursor: default;
  padding-left: 3%;
  border-radius: 6px;
}
</style>